import { render, staticRenderFns } from "./recipe.vue?vue&type=template&id=5d23c6c0&scoped=true"
import script from "./recipe.vue?vue&type=script&lang=js"
export * from "./recipe.vue?vue&type=script&lang=js"
import style0 from "./recipe.vue?vue&type=style&index=0&id=5d23c6c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d23c6c0",
  null
  
)

export default component.exports